/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = { fromText: 'fromText', perPersonText: 'perPersonText' }; export default Keys;